import { GET_ALL_ADS } from "./actions";

const initialState = {
  adsList: {
    docs: [],
    totalDocs: 0,
    limit: 10,
    page: 1,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },

  loading: true,
};

const purchaseAdsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_ALL_ADS:
      return {
        ...state,
        adsList: payload,
        loading: false,
      };

    default:
      return state;
  }
};
export default purchaseAdsReducer;
